<template>
    <ui-PanelOverlay panel="config" :id="`componet_${_uid}`" :show="show" :loading="loading">
        <template v-slot:menuBar>
            <PanelMixinBack></PanelMixinBack>
        </template>
        <template v-slot:body>
            <ui-RichMenu :name="$dicc.configUserPanel.title" :navigation="true">
                <template v-slot:options>
                    <FormMixinInput type="email" :label="$dicc.user.email" property="email"></FormMixinInput>
                    <FormMixinInput
                        type="password"
                        :label="$dicc.configUserPanel.passChange"
                        property="password"
                    ></FormMixinInput>
                    <FormMixinInput
                        type="password"
                        :label="$dicc.configUserPanel.passChangeConfirmation"
                        property="password_confirmation"
                    ></FormMixinInput>
                    <label v-if="false">{{ msgError }}</label>
                    <div class="richMenu__actions">
                        <a class="btn btn--simple" @click="$refs.removeUser.open()">{{
                            $dicc.configUserPanel.deleteAccountAction
                        }}</a>
                        <a class="btn btn--simple" @click="doUpdateUser">{{ $dicc.confirm }}</a>
                    </div>
                </template>
            </ui-RichMenu>
            <ui-Modal ref="removeUser" :closeText="$dicc.close">
                <template v-slot:head>
                    <p>{{ $dicc.configUserPanel.alertConfirmTitle }}</p>
                </template>
                <template v-slot:body>
                    <p>{{ $dicc.configUserPanel.alertConfirmDescription }}</p>
                </template>
                <template v-slot:actions>
                    <a class="btn btn--simple" @click="doDeleteUser">{{ $dicc.delete }}</a>
                </template>
            </ui-Modal>
        </template>
    </ui-PanelOverlay>
</template>

<script>
    // :class="{ modeHeat: device.status.m != '0' }" class="fulldevice"
    import { PanelMixin } from '../mixins/PanelMixin';
    import { FormMixin } from '../mixins/FormMixin';

    export default {
        name: 'ConfigUserPanel',
        mixins: [PanelMixin, FormMixin],
        props: {},
        data: function() {
            return {
                type: 'config',
            };
        },
        methods: {
            init() {
                if (this.show) this.getUser();
                else this.fillModel(this.$session.getUser());
            },

            fillModel(objUser) {
                this.$set(this, 'model', {
                    email: objUser.email,
                    password: '',
                    password_confirmation: '',
                });
            },

            getUser() {
                this.loading++;

                this.$api.getUser(
                    (data) => {
                        this.$session.setUpdateUser(data.entity);
                        this.fillModel(this.$session.getUser());
                    },
                    null,
                    () => this.loading--
                );
            },

            doDeleteUser: function() {
                this.loading++;
                this.resetErrors();

                this.$api.deleteUser(
                    this.model,
                    (data) => {
                        this.$session.logout();
                        this.$toast({
                            message: this.$dicc.configUserPanel.deleted,
                            container: '.LoginView',
                            type: 'is-success',
                        });
                        this.$router.push({ name: 'Login' });
                    },
                    (error) => this.showError(error),
                    () => this.loading--
                );
            },

            doUpdateUser: function() {
                let userToUpdate = {};

                this.loading++;
                this.resetErrors();

                if (!!this.model.password && !!this.model.password_confirmation) {
                    userToUpdate = this.model;
                } else {
                    userToUpdate = {
                        email: this.model.email,
                        redirect_uri: this.$router.getFullRoute({ name: 'Verify' }),
                    };
                }

                this.$api.updateUser(
                    userToUpdate,
                    (data) => {
                        this.$session.setUpdateUser(data.entity);
                        this.$toast({
                            message: this.$dicc.configUserPanel.updated,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        });
                        //this.$router.push({ name: 'Validate' });
                    },
                    (error) => this.showError(error),
                    () => this.loading--
                );
            },
        },
        watch: {
            show: {
                immediate: true,
                handler() {
                    this.init();
                },
            },
        },
    };
</script>
